import Vue from 'vue'
import router from '@/router/index'
import { Route } from 'vue-router'
import { Message } from 'element-ui'

import {
  getToken,
  removeToken
} from '@/utils/auth'
import {
  checkPermission
} from '@/api/module/login/login'
import store from '@/store/'

import { profileModule } from '@/store/modules/profile'

 
const namespace = 'profileModule'


const whiteList = ['/pages/login', '/auth-redirect',"/pages/loginEntrance","/pages/test","/pages/reset"]

router.beforeEach(async(to:Route, from:Route, next:any) => {




  if (getToken()) {

    console.log("存在本地缓存");

    store
      .dispatch("profileModule/GetUserInfo")
      .then(response => {

        console.log("成功获取个人信息");
        
        if (to.path === '/pages/login' || to.path == '/pages/test') {
          next({
            path: '/'
          });
        } else {

          // 检查权限
          if (checkPermission(to)) {
            next();
          } else {
            next({
              path: '/dashboard'
            });
          }
        }

      })
      .catch(error => {
        // console.log("GetUserInfo 错误");
        // console.log(error);
        Message.error("登录已过期，需要重新登录");


        removeToken();
        next({
          path: '/'
        });

      })
      .finally(() => {});

  } else {
    console.log("没有本地缓存");

    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/pages/loginEntrance`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to:Route) => {
})

